<template>
  <div id="sticker_content">
    <div class="row" v-for="row in trekkers">
      <div class="column-first"></div>
      <div class="column-second col-md-10">
        <div style="text-align: center;" class="title">
          <b>
            {{ 'Trekking Permit' }}
          </b>
        </div>
        <div class="line"><span class="label">Trekking Permit No:</span><span class="value">{{ row.permit_no }}</span> </div>
        <div class="line"><span class="label">Trekking Sticker Serial No:</span><span class="value">{{ row.sticker_serial_no }}</span></div>
        <div class="line"><span class="label">Validity:</span><span class="value">{{
            trekkingData.starting_date
          }} to {{ trekkingData.end_date }} ( {{ trekkingData.no_of_days }} DAYS )</span></div>
        <div class="line"><span class="label">Trekking Area:</span><span
            class="value">{{ trekkingData.trekkingRoute.name }}</span></div>
        <div class="line"><span class="label">Issued At:</span><span class="value">{{ appliedOffice }}</span></div>
        <div class="line"><span class="label">Issued Date:</span><span class="value">{{ appliedAt }}</span></div>
        <div class="line"><span class="label">Document Number:</span><span class="value">{{
            row.passport_number
          }}</span></div>
        <div class="line"><span class="label">Officer:</span><span class="value">{{ approvedUser }}</span></div>
        <div id="qrcode" v-html="generateQrCode(row)"></div>
      </div>
    </div>
  </div>

</template>

<script>
import {BASE_URL} from "../../config/config";
import moment from "moment";

const qrCode = require('qrcode-generator');
export default {
  name: "print",
  props: ['trekkers', 'trekkingData', 'trekkingAgency', 'total_cost', 'trekkingRoute', 'user'],
  data() {
    return {
      logo: BASE_URL + 'logo.png'
    }
  },
  computed: {
    approvedUser() {
      let approvedTracks = this.trekkingData.tracks.filter(item => {
        return item.statusNumber === 35;
      })
      return approvedTracks[0].user.name;
    },
    freeTrekkers() {
      return this.trekkers.filter(item => {
        return item.isFree === 'true';
      })
    },
    appliedOffice() {
      let appliedTracks = this.trekkingData.tracks.filter(item => {
        return item.statusNumber === 68;
      })

      return appliedTracks[0] && appliedTracks[0].extra ? appliedTracks[0].extra.office : 'N/A';
    },
    appliedAt() {
      let appliedTracks = this.trekkingData.tracks.filter(item => {
        return item.statusNumber === 68;
      })

      return appliedTracks[0] && appliedTracks[0].created_at ? moment(appliedTracks[0].created_at).format('Y-MM-DD') : 'N/A';
    }
  },
  methods: {
    generateQrCode(item) {
      var typeNumber = 0;
      var errorCorrectionLevel = 'L';
      var qr = qrCode(typeNumber, errorCorrectionLevel);
      qr.addData(item.permit_no +
          '\n' + this.trekkingData.starting_date + ' to ' + this.trekkingData.end_date + ' ( ' + this.trekkingData.no_of_days + ' )  DAYS' +
          '\n' + item.passport_number);
      qr.make();
      // item.qrCodeImage = qr.createImgTag(10);
      return qr.createImgTag(2);
    }
  },
}
</script>

<!--<style scoped>-->

<!--.title {-->
<!--  font-size: 30px;-->
<!--}-->
<!--.column-second {-->
<!--  margin-left: 40px;-->
<!--}-->

<!--.line {-->
<!--  margin-bottom: 0;-->
<!--  margin-top: 0;-->
<!--}-->

<!--.label {-->
<!--  font-size: 20px;-->
<!--}-->

<!--.value {-->
<!--  font-size: 25px;-->
<!--  font-weight: bold;-->
<!--  margin-left: 8px;-->
<!--}-->

<!--@media print {-->
<!--  * {-->
<!--    font-family: sans-serif;-->
<!--    box-sizing: border-box;-->
<!--  }-->

<!--  /* Create two equal columns that floats next to each other */-->
<!--  .column-first {-->
<!--    float: left;-->
<!--    width: 8%;-->

<!--    /*padding: 10px;*/-->
<!--    margin-right: 18px;-->
<!--    height: 770px; /* Should be removed. Only for demonstration */-->
<!--  }-->

<!--  .column-second {-->
<!--    /*margin-left: 15px;*/-->
<!--    /*height: 100vh;*/-->
<!--  }-->

<!--  /* Clear floats after the columns */-->
<!--  .row:after {-->
<!--    content: "";-->
<!--    display: table;-->
<!--    clear: both;-->
<!--  }-->

<!--  @page {-->
<!--    size: A4 landscape;-->
<!--  }-->

<!--  .title {-->
<!--    font-size: 70px;-->
<!--    margin-bottom: 10px-->
<!--  }-->

<!--  .line {-->
<!--    margin-bottom: 20px;-->
<!--    margin-top: 20px;-->
<!--  }-->

<!--  .label {-->
<!--    font-size: 40px;-->
<!--  }-->

<!--  .value {-->
<!--    font-size: 45px;-->
<!--    font-weight: bold;-->
<!--    margin-left: 8px;-->
<!--  }-->

<!--  .qr {-->
<!--    float: right;-->
<!--    margin-top: -300px;-->
<!--    margin-right: 10px;-->
<!--  }-->
<!--}-->
<!--</style>-->
